import classNames from "classnames"
import ReactHtmlParser from "react-html-parser"

import { manageFilmVersions, manageTechnicals, restoredVersion } from "lib/tools/product"
import classification from "lib/tools/classification"
import notation from "lib/products/notation"
import { useTranslation } from "lib/i18n/translation"

import { FilmVersion } from "components/modals/film-version"

import { Actions } from "./actions"

export const Sheet = ({ product, details, loading }) => {
	const {
		description,
		actors
	} = product

	const { c } = useTranslation("common")

	const filmVersions = manageFilmVersions(details, c)
	const isRestoredVersion = restoredVersion(details, c)
	const technicals = manageTechnicals(details)

	return (
		<section>
			<Actions product={product} isSingle />
			<div className="splitted">
				<div
					className={classNames(
						"content",
						{
							"skeleton": loading
						}
					)}
				>
					{ReactHtmlParser(description)}
					<p className={classNames("is-recommended", { "skeleton": loading })}>
						<b>{c("with")}</b>
						{actors.map(actor => actor.name).join(", ")}
					</p>
				</div>
				<aside>
					{filmVersions.find(v => v.value !== c("none")) && (
						<ul className="film-versions list">
							{filmVersions.map((filmVersion, index) => (
								filmVersion.tooltipValue
									? <FilmVersion key={`film-versions-${index}`} filmVersion={filmVersion} />
									: filmVersion.value === c("none")
										? (
											<li key={`film-versions-${index}`} className="unavailable">
												<span className={filmVersion.name}>{c(filmVersion.name)} </span>
												{c("none")}
											</li>
										)
										: (
											<li key={`film-versions-${index}`}>
												<span className={filmVersion.name}>{c(filmVersion.name)} </span>
												{filmVersion.value}
											</li>
										)
							))}
						</ul>
					)}

					<h3 className={classNames({ "skeleton": loading })}>
						{c("status-vod-copy")}
					</h3>
					<div className={classNames("film-status", { "skeleton": loading })}>
						{isRestoredVersion && (
							<p><span className="alert restored small">{c("restored-version")}</span></p>
						)}

						<span className="notation" data-stars={notation(technicals, c)}>
							{technicals.copy}
						</span>

						<span>{technicals.copy || c("film-copy-not-set")}</span>

						{(technicals.videoFormat || technicals.sound) && (
							<div className="equipment">
								[ {technicals.videoFormat ? <><span>{technicals.videoFormat}</span> - </> : ""}{technicals.sound ? <span>{technicals.sound}</span> : ""} ]
							</div>
						)}
						{classification(product)}
					</div>
				</aside>
			</div>
		</section>
	)
}
